import { render } from "./x-ray-view.vue?vue&type=template&id=bda3f988&scoped=true"
import script from "./x-ray-view.vue?vue&type=script&lang=js"
export * from "./x-ray-view.vue?vue&type=script&lang=js"

import "./x-ray-view.vue?vue&type=style&index=0&id=bda3f988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda3f988"]])

export default __exports__